// Zod-free leaf module: plain enums only (RET1-2734). Keep this file free of
// imports so lean bundles can use these values without loading zod schemas.

export enum DateSubconditionType {
  ALL_TIME = "All time",
  ON_OR_BEFORE = "On or before",
  ON_OR_AFTER = "On or after",
  BETWEEN = "Between",
  LAST_N_DAYS = "Last n days",
}
